import React, { useEffect, useState } from "react";
import { MainRouter } from "@routes/index";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider as ReduxProvider } from "react-redux";
import store from "@store/store";
import { ThemeProvider } from "emotion-theming";
import { theme } from "nectar-ui";
import { ReactQueryDevtools } from "react-query/devtools";
import { AstreaUtilitiesProvider } from "./context/astreaUtilities/astreaUtilitiesContext";
import { UserInfoProvider } from "@context/userInfo/userInfoContext";
import { getUserInfoFromCookies } from "@helpers/applicationHelpers";

const TEN_MINUTES = 1000 * 60 * 10;
const FIFTEEN_MINUTES = 1000 * 60 * 15;
const MAX_QUERY_RETRIES = 3;

const shouldRetryQuery = (failureCount, error) => {
  const statusCode = error?.response?.status;
  const isClientError = statusCode >= 400 && statusCode < 500;

  return !isClientError && failureCount < MAX_QUERY_RETRIES;
};

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: TEN_MINUTES,
        cacheTime: FIFTEEN_MINUTES,
        refetchOnWindowFocus: false,
        retry: shouldRetryQuery,
      },
    },
  });

const CustomerAccessModule = (props) => {
  const [queryClient] = useState(createQueryClient);

  useEffect(() => {
    document.title = "Portal do Cliente - Astrea";
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AstreaUtilitiesProvider value={{ logout: props.logout }}>
        <UserInfoProvider value={getUserInfoFromCookies()}>
          <ThemeProvider theme={theme.standard}>
            <ReduxProvider store={store}>
              <MainRouter />
            </ReduxProvider>
          </ThemeProvider>
        </UserInfoProvider>
      </AstreaUtilitiesProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

CustomerAccessModule.propTypes = {
  logout: () => {},
};

export default CustomerAccessModule;
